const fontStyles = {
	regular: `Inter-Regular`,
	bold: `Inter-Bold`,
	black: `Inter-Black`,
	mono: `InterMono-Regular`,
	monoBold: `InterMono-Bold`,
	semiBold: `Inter-SemiBold`,
	compressedBlack: `GT-America-Compressed-Black`,
	compressedMedium: `GT-America-Compressed-Medium`,
}

export default fontStyles
